import { Controller } from "@hotwired/stimulus"
import FractionInput from "@components/fraction-input.svelte"
import { mount, unmount } from "svelte"
import { isPreviewMode } from "@lib/utils"

const COMPONENT_KEY = "__svelteComponent"

// Connects to data-controller="fraction-input-svelte"
export default class extends Controller {
  connect() {
    if (isPreviewMode()) return
    
    const data = JSON.parse(this.element.dataset.json)
    this.teardown()
    if (this.beforeCache) document.removeEventListener("turbo:before-cache", this.beforeCache)
    this.beforeCache = () => this.teardown()
    document.addEventListener("turbo:before-cache", this.beforeCache)

    const component = mount(FractionInput, {
      target: this.element,
      props: data
    })
    this.component = component
    this.element[COMPONENT_KEY] = component
  }

  disconnect() {
    if (this.beforeCache) {
      document.removeEventListener("turbo:before-cache", this.beforeCache)
      this.beforeCache = null
    }
    this.teardown()
  }

  teardown() {
    const existing = this.element[COMPONENT_KEY] || this.component
    if (existing) unmount(existing)
    this.element[COMPONENT_KEY] = null
    this.component = null
    this.element.innerHTML = ""
  }
}
